import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDocuments } from "../../redux/actions/actionDocument";
import DocumentsPutCard from "./documentPutCard";
import LoadingIcons from "react-loading-icons";

export default function DocumentPut() {
    const dispatch = useDispatch();
    const documents = useSelector((state) => state.documents.allDocuments);     
    const [clientFind, setClientFind] = useState();
    const [clientInput, setClientInput] = useState("");


    useEffect(() => {
        dispatch(getDocuments());        
    }, [dispatch])

    console.log(documents[0])

    const documentsNoSaldado = documents[0] !== undefined ? documents[0].filter(e => e.state === false ) : null;
    console.log(documentsNoSaldado)

    const handleChange = (e) => {
        const { value } = e.target
        setClientInput(value)
      }
  
      const filterClient = () => {
         console.log(clientInput);
          if (clientFind === undefined) {
            let result = documentsNoSaldado.filter((e) => {
              if (
                e.client_id.name
                  .toString()
                  .toLowerCase()
                  .includes(clientInput.toLowerCase())
                  || e.client_id.lastName
                  .toString()
                  .toLowerCase()
                  .includes(clientInput.toLowerCase())
                  || e.client_id.nameCompany
                  .toString()
                  .toLowerCase()
                  .includes(clientInput.toLowerCase())
                   ) {
                console.log(e)
                return e;
              }
            });
            setClientFind(result);
          } else {
            let result = clientFind.filter((e) => {
              if (
                e.client_id.name
                  .toString()
                  .toLowerCase()
                  .includes(clientInput.toLowerCase())
                  || e.client_id.lastName
                  .toString()
                  .toLowerCase()
                  .includes(clientInput.toLowerCase())
                  || e.client_id.nameCompany
                  .toString()
                  .toLowerCase()
                  .includes(clientInput.toLowerCase())
                ) {
                  console.log(e)
                  return e;
                }
              });
              setClientFind(result);
            }
          };
  
          const handleLimpiar = () => {
            console.log(clientFind);
            setClientFind(documentsNoSaldado)
          }

    return (
        <div className="container bg-gray-900">
            <div>
            <div>
                <p className="text-[20pt] h-10 ml-2 mt-4 pb-8 underline text-orange-500">
                    Remitos - Modificar
                </p>
            </div>
            <div className="h-24 pl-2 pt-2 mt-4 bg-cyan-900  ">
            <div className="flex flex-row text-[12px] w-56 font-bold text-yellow-500 pt-1 pl-5">
            <p className="mr-2">Buscar</p>
            <input
              className="border border-slate-700 rounded w-44 h-4 text-center bg-cyan-600 placeholder-yellow-400"
              type="text"
              placeholder="Nombre Cliente"
              onChange={handleChange}
              
            />
          </div>
          <div className="w-56 text-center">
            <button className="w-16 ml-14 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={filterClient}>Buscar</button>
            <button className="w-16 h-6 ml-2 text-[10pt] font-bold text-yellow-500 hover:text-white hover:text-[11pt]" onClick={handleLimpiar}>Limpiar</button>
          </div>
            </div>
            <div className="">
                <div className="flex font-bold text-[14px] text-orange-500">
                    <div className="w-12">Doc N°</div>
                    <div className="w-60">Cliente</div>
                    <div className="w-5/12">Domicilio Evento</div>
                    <div className="w-20">Fecha de Salida</div>
                    <div className="w-20">Fecha de Entrada</div>
                </div>
                <div className="max-h-screen overflow-y-auto">
                  {documentsNoSaldado === null ? <div className="flex h-[400px] items-center justify-center"><LoadingIcons.Bars /></div> :
                clientFind === undefined ?
                 documentsNoSaldado && documentsNoSaldado.map(e=> {
                    return (
                        <div key={e._id}>
                <DocumentsPutCard 
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    nameCompany={e.client_id.nameCompany}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}                    
                    numberDocument={e.numberDocument}                                        
                />
                </div>
                 )})
                 : 
                 clientFind.map(e =>{
                    return(
                        <div key={e._id}>
                           <DocumentsPutCard 
                    key={e._id}
                    id={e._id}
                    addressEvent={e.addressEvent}
                    nameCompany={e.client_id.nameCompany}
                    dateReception={e.dateReception}
                    dateSend={e.dateSend}                    
                    numberDocument={e.numberDocument}                                        
                /> 
                        </div>
                    )
                 })
                 }
                </div>
            </div>
        </div>
        </div>
    )
}

